import { Box, Card, CardContent, CardHeader, Typography, Stack } from '@mui/material';

import { TextField } from '@occc-app/design-system';

import {
  DEFAULT_SCREEN_DETAILS_SECTION_TITLE,
  DEFAULT_SCREEN_NAME_LABEL,
  DEFAULT_SCREEN_DESCRIPTION_LABEL,
} from '../../touchpoint.constants';

export const DefaultScreenDetailsSection = () => {
  return (
    <Box mb={2}>
      <Card>
        <CardHeader
          title={
            <Typography variant='subtitle1' paragraph>
              {DEFAULT_SCREEN_DETAILS_SECTION_TITLE}
            </Typography>
          }
        />
        <CardContent>
          <Stack direction='row' spacing={3}>
            <TextField name='name' label={DEFAULT_SCREEN_NAME_LABEL} required />
            <TextField name='description' label={DEFAULT_SCREEN_DESCRIPTION_LABEL} required />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};
